import React,{ useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import LeftImageContainer from "./left-image";
import RightMessageContainer from "./right-message";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { useWebp } from "../../../../../hooks/common";

const ProductMainContainer = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { selectedProduct } = productHooks;
    const isWebp = useWebp() && selectedProduct?.status === '1';
    const imagePrefix = `${IMAGE_GEEKO_LTD}${isWebp ? '/webp':''}`;
    const [hoverImage,setHoverImage] = useState(null);

    return <div className={classes.ProductMainContainer}>
        <LeftImageContainer 
            {...props}
            hoverImage={hoverImage}
            imagePrefix={imagePrefix}
        />
        <RightMessageContainer 
            {...props} 
            changeHoverImage={(image)=>setHoverImage(image)}
            imagePrefix={imagePrefix}
        />
    </div>
}

export default ProductMainContainer;